import { render, staticRenderFns } from "./CareGoals.vue?vue&type=template&id=351aef37&scoped=true"
import script from "./CareGoals.vue?vue&type=script&lang=ts"
export * from "./CareGoals.vue?vue&type=script&lang=ts"
import style0 from "./CareGoals.vue?vue&type=style&index=0&id=351aef37&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351aef37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351aef37')) {
      api.createRecord('351aef37', component.options)
    } else {
      api.reload('351aef37', component.options)
    }
    module.hot.accept("./CareGoals.vue?vue&type=template&id=351aef37&scoped=true", function () {
      api.rerender('351aef37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/CareGoals.vue"
export default component.exports